import { render } from "./NewDonorEducationalPamphletMobile.vue?vue&type=template&id=360ef04e"
import script from "./NewDonorEducationalPamphletMobile.vue?vue&type=script&lang=js"
export * from "./NewDonorEducationalPamphletMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__